import updateAuthenticationState from './updateAuthenticationState';

export default {
    Mutation: {
        updateAuthenticationState
    }
};